import { httpFetch } from '../../Utils/httpUtils'
import { internalCustomerAdminActionTypes as actionTypes } from '../../ActionTypes/InternalCustomerAdmin/internalCustomerAdminActionTypes'
import commonActions from '../commonActions';
import { commonActionTypes } from '../../ActionTypes/commonActionTypes';

const activityLogActions = {

    searchLogs(data) {
        return (dispatch) => {

            dispatch(commonActions.progressLoader(true));
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "eventLogs", value: true });

            const params = new URLSearchParams();

            if (data.customerId) params.append('customerId', data.customerId);
            if (data.clientId) params.append('clientId', data.clientId);
            if (data.subscriptionId) params.append('subscriptionId', data.subscriptionId);
            if (data.fromDate) params.append('from', data.fromDate);
            if (data.toDate) params.append('to', data.toDate + 'T23:59:59');

            const queryString = params.toString();

            const parseLogs = (logs) => {
                logs.forEach(log => {
                    if (log.content) {
                        try {
                            const parsed = JSON.parse(log.content);
                            log.content = parsed; // Store parsed content as object
                            log.info = parsed?.name ?? parsed?.package?.name ?? null;
                            log.performerEmail = parsed?.performerEmail ?? parsed?.PerformerEmail ?? '';
                        } catch (e) {
                            // If parsing fails, leave content as string
                        }
                    }
                })
            }
            
            return httpFetch(`/api/ActivityLog/Search?${queryString}`, dispatch)
                .then(json => {
                    parseLogs(json);
                    dispatch({ type: actionTypes.STORE_EVENT_LOGS, data: json });
                })
                .catch(error => {
                    console.error(error);
                    dispatch({ type: actionTypes.STORE_EVENT_LOGS, data: [] });
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "eventLogs", value: false });
                });
        }
    },

    clear: (key) => {
        return (dispatch) => {
            dispatch({ type: actionTypes.CLEAR, key });
        }
    },
    
    searchFailedMails(data) {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "emailDeliveryLogs", value: true });
            const params = new URLSearchParams();
            if (data.value) params.append('email', data.value);
            if (data.fromDate) params.append('fromDate', data.fromDate);
            if (data.toDate) params.append('toDate', data.toDate + 'T23:59:59');
            const queryString = params.toString();
            return httpFetch(`/api/ActivityLog/GetFailedMails?${queryString}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_EMAIL_DELIVERY_LOGS, data: json });
                })
                .catch(error => {
                    console.error(error);
                    dispatch({ type: actionTypes.STORE_EMAIL_DELIVERY_LOGS, data: [] });
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "emailDeliveryLogs", value: false });
                });
        }
    },

    searchEvents(data) {
        dispatch(commonActions.progressLoader(true));
        dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "activityLogs", value: true });
        return httpFetch(`/api/ActivityLog/Search?searchBy=${data.searchBy}&value=${data.value}&fromDate=${data.fromDate}&toDate=${data.toDate}&applicationId=${data.applicationId}`, dispatch)
            .then(json => {
                dispatch({ type: actionTypes.STORE_ACTIVITY_LOGS, data: json });
            })
            .catch(error => {
                console.error(error);
                dispatch({ type: actionTypes.STORE_ACTIVITY_LOGS, data: [] });
            })
            .finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "activityLogs", value: false });
            });

    }
}
export default activityLogActions;